import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MobileMenu from "./mobileMenu";
import menu from "../icons/icon-hamburger.svg";
import close from "../icons/icon-close.svg";

const Nav = () => {
  const location = useLocation();
  const [url, setUrl] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setUrl(location.pathname);
  }, [location]);

  const updateOverflow = () => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
  };

  const closeMobileMenu = () => setOpen(false);

  return (
    <nav className="py-10 px-5 md:p-10 lg:px-10 xl:px-20 lg:py-10">
      <div className="block flex items-center justify-between">
        <a className="text-2xl font-bold font-elianto uppercase" href="/">
          KA
        </a>

        <ul className="hidden lg:w-4/12 lg:block lg:flex lg:items-center lg:justify-between">
          <li>
            <Link
              to="/"
              className={
                "hover:text-white text-gray-400 font-ailerons text-lg" +
                (url === "/" ? " active" : "")
              }
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={
                "hover:text-white text-gray-400 font-ailerons text-lg" +
                (url === "/about" ? " active" : "")
              }
            >
              About
            </Link>
          </li>
          <li>
            <Link
              to="/portfolio"
              className={
                "hover:text-white text-gray-400 font-ailerons text-lg" +
                (url === "/portfolio" ? " active" : "")
              }
            >
              Portfolio
            </Link>
          </li>
          <li>
            <a
              href="mailto:princekelvx@gmail.com"
              className="hover:text-white text-gray-400 font-ailerons text-lg"
            >
              Contact
            </a>
          </li>
        </ul>

        <div className="lg:hidden z-10" onClick={() => setOpen(!open)}>
          <img src={!open ? menu : close} alt="menu" />
        </div>
        {open && <MobileMenu closeMobileMenu={closeMobileMenu} />}
        {updateOverflow()}
      </div>
    </nav>
  );
};

export default Nav;
